import {isTagValueStructuredTableColumn} from 'notebook/structured-tables/columns/TypePredicates';
import {
  LastSyncedUpstreamValue,
  StructuredTableColumn,
} from 'notebook/structured-tables/StructuredTableConstants';

import getLastSyncedUpstreamValue from './getLastSyncedUpstreamValue';

export default function getLastSyncedUpstreamValueForColumn(
  lastSyncedUpstreamValues: Array<LastSyncedUpstreamValue>,
  column: StructuredTableColumn
): LastSyncedUpstreamValue | null {
  const fieldApiId = isTagValueStructuredTableColumn(column) ? column.schemaFieldApiId : null;
  return getLastSyncedUpstreamValue(lastSyncedUpstreamValues, {
    columnType: column.columnType,
    columnGroup: column.columnGroup ?? null,
    columnProvenanceUuid: column.provenanceUuid ?? null,
    fieldId: fieldApiId,
  });
}
